export default [
  // Main Page
  {
    path: 'estimated-profit',
    name: 'website.estimated-profit',
    component: () => import('@/views/website/estimated-profit'),
  },
];
